import React, { useState, useEffect, useContext, useRef } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  DirectLinkList,
  AddDirectLink,
  UpdatedDirectLink,
} from "../../app/api";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
  Badge,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import {
  Block,
  BlockHead,
  BlockBetween,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  Icon,
  Button,
  PaginationComponent,
} from "../../components/Component";
import Loader from "../../app/Loader";
import AppContext from "../../context/AppContext";
import DirectLinkRow from "./DirectLinkRow";

export const PubDirectLink = () => {
  const ctx = useContext(AppContext);
  const { handleSubmit } = useForm();
  const [sm, updateSm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editeventId, setEditeventId] = useState(0);
  const [data, setData] = useState([]);
  const [pgs, setPgs] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [adStatus, setAdStatus] = useState("");
  const [adStatusfilter, setAdStatusfilter] = useState("");
  const [modalTabForm, setModalTabForm] = useState(false);
  const toggleTabForm = () => setModalTabForm(!modalTabForm);
  const [errors, setErrors] = useState({});
  const debounceTimeout = useRef(null);
  const [statusFilter, setStatusFilter] = useState('All');

  const filteredData = data.filter((item) => {
    if (statusFilter === 'All') return true;
    const filterValue = Number(statusFilter);
    if (filterValue === 3) {
      return item.suspended === 1;
    }

    return item.status === filterValue && item.suspended != 1;
  });

  const [formData, setFormData] = useState({
    link_title: "",
    is_adult: 1,
    is_mainstream: 1,
  });
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    const alphaNumericRegex = /^[a-zA-Z0-9\s]*$/;
    let newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    if (type === "checkbox") {
      return;
    }

    if (!alphaNumericRegex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: 'Special characters are not allowed.',
      }));
      return;
    }

    if (value.length > 30) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: 'Must be 30 characters or fewer',
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
    }
    if (errors[name] || errors.ads) {
      setErrors((prev) => ({ ...prev, [name]: "", ads: "" }));
    }
  };

  const getWebData = async (adsts = "", src = "", pg = 0, lim = 0, mststs = "") => {
    setLoading(true);
    let itemLim = lim > 0 ? lim : itemPerPage;
    let pgn = pg === 0 ? currentPage : pg;
    let uid = localStorage.getItem("uid");
    let res = await DirectLinkList(uid, "popup", adsts, src, itemLim, pgn);
    if (res.code === 200) {
      setData(res.data);
      setPgs(res.row);
    } else {
      setPgs(0);
      setData([]);
    }
    ctx.dispatch({
      type: "wlt",
      wlt: res.wallet,
    });
    setLoading(false);
  };

  const [skey, setSkey] = useState("");

  const onCampSearch = (val) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      let src = val.target.value;
      let src2 = src.length > 0 ? src : 0;
      setSkey(src);
      getWebData("", src2);
    }, 1000);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (currentPage !== pageNumber) {
      getWebData("", skey, pageNumber);
    }
  };

  // submit function to add a new item
  const onFormSubmit = async () => {
    const validationErrors = {};
    if (formData.link_title === undefined) {
      validationErrors.link_title = "Link title is required!";
    }
    if (formData.is_adult == 0 && formData.is_mainstream == 0) {
      validationErrors.ads = "Please select at least one: Adult or Mainstream";
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    let isadult = formData.is_adult ?? 1;
    let ismainstream = formData.is_mainstream ?? 1;
    let isadultu = String(formData.is_adult) === "1" ? "1" : "0";
    let ismainstreamu = String(formData.is_mainstream) === "1" ? "1" : "0";
    let uid = localStorage.getItem("uid");
    setLoading(true);
    let res;
    if (editeventId > 0) {
      res = await UpdatedDirectLink(formData.id, formData.uid, formData.link_title, isadultu, ismainstreamu);
    } else {
      res = await AddDirectLink(uid, formData.link_title, isadult, ismainstream);
    }
    if (res.code === 200) {
      let message = editeventId > 0 ? "Direct Link updated successfully." : "Direct link created successfully.";
      toast.success(message, {
        position: "top-right",
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: false,
      });
      // toast.success(message);
      setModalTabForm(false);
      setLoading(false);
      getWebData();
    } else {
      if (res.code === 100) {
        setLoading(false);
        setErrors(res.error);
      } else if (res.code === 422) {
        toast.error(res.message);
        setLoading(false);
      } else {
        toast.error("Something went wrong!");
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getWebData();
  }, []);

  return (
    <>
      <React.Fragment>
        <Head title="Direct Link"></Head>
        <Content>
          <Loader visible={loading} />
          <BlockHead size="sm">
            <BlockBetween>
              <BlockHeadContent>
                <BlockTitle page> Direct Link</BlockTitle>
                <BlockDes className="text-soft">
                  You have total {pgs} Direct Link
                </BlockDes>
              </BlockHeadContent>
              <BlockHeadContent>
                <div className="toggle-wrap nk-block-tools-toggle">
                  <Button
                    className={`btn-icon btn-trigger toggle-expand mr-n1 ${sm ? "active" : ""
                      }`}
                    onClick={() => updateSm(!sm)}
                  >
                    <Icon name="menu-alt-r"></Icon>
                  </Button>
                  <div
                    className="toggle-expand-content"
                    style={{ display: sm ? "block" : "none" }}
                  >
                    <ul className="nk-block-tools  g-3">
                      <li>
                        <div className="form-control-wrap">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            id="default-04"
                            placeholder="Search by Title or Link ID"
                            title="Search by Title or Link ID"
                            onChange={(e) => onCampSearch(e)}
                          />
                        </div>
                      </li>
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            className="dropdown-toggle btn btn-white btn-dim btn-outline-light"
                          >
                            <Icon
                              name="filter-alt"
                              className="d-none d-sm-inline"
                            ></Icon>
                            <span>By Type {adStatus}</span>
                            <Icon
                              name="chevron-right"
                              className="dd-indc"
                            ></Icon>
                          </DropdownToggle>
                          <DropdownMenu right>
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    getWebData("", skey, currentPage);
                                    setAdStatus("All");
                                  }}
                                >
                                  {" "}
                                  <span>All</span>
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    getWebData("1", skey, currentPage);
                                    setAdStatus("Adult");
                                  }}
                                >
                                  <span>Adult</span>
                                  {adStatus === "Adult" && (
                                    <Icon
                                      name="check"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    getWebData("2", skey, currentPage);
                                    setAdStatus("Mainstream");
                                  }}
                                >
                                  <span>Mainstream</span>
                                  {adStatus === "Mainstream" && (
                                    <Icon
                                      name="check"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    getWebData("3", skey, currentPage);
                                    setAdStatus("Both");
                                  }}
                                >
                                  <span>Both</span>
                                  {adStatus === "Both" && (
                                    <Icon
                                      name="check"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            className="dropdown-toggle btn btn-white btn-dim btn-outline-light"
                          >
                            <Icon
                              name="filter-alt"
                              className="d-none d-sm-inline"
                            ></Icon>
                            <span>By Status {adStatusfilter}</span>
                            <Icon
                              name="chevron-right"
                              className="dd-indc"
                            ></Icon>
                          </DropdownToggle>
                          <DropdownMenu right>
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    //getWebData("", skey, currentPage);
                                    setStatusFilter("All");
                                    setAdStatusfilter("All");
                                  }}
                                >
                                  {" "}
                                  <span>All</span>
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    // getWebData("1", skey, currentPage);
                                    setStatusFilter(0);
                                    setAdStatusfilter("Active");
                                  }}
                                >
                                  <span>Active</span>
                                  {adStatusfilter === 0 && (
                                    <Icon
                                      name="check"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    //getWebData("2", skey, currentPage);
                                    setStatusFilter(1);
                                    setAdStatusfilter("InActive");
                                  }}
                                >
                                  <span>InActive</span>
                                  {adStatusfilter === 1 && (
                                    <Icon
                                      name="check"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setStatusFilter(2);
                                    setAdStatusfilter("Hold");
                                  }}
                                >
                                  <span>Hold</span>
                                  {adStatusfilter === 1 && (
                                    <Icon
                                      name="check"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setStatusFilter(3);
                                    setAdStatusfilter("Suspended");
                                  }}
                                >
                                  <span>Suspended</span>
                                  {adStatusfilter === 1 && (
                                    <Icon
                                      name="check"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                      <li className="nk-block-tools-opt">
                        <Button
                          color="primary"
                          onClick={() => {
                            setErrors("");
                            setModalTabForm(true);
                            setEditeventId("");
                            setFormData("");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Add Direct Link</span>
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
          <Block>
            <div class="card-bordered card-stretch boxscroll card">
              <div class="card-inner-group">
                <div class="card-inner p-0 ">
                  <div class="nk-tb-list nk-tb-ulist p-0">
                    <div class="nk-tb-item nk-tb-head">
                      <div class="nk-tb-col"><span class="sub-text">SN</span></div>
                      <div class="nk-tb-col"><span class="sub-text">Title</span></div>
                      <div class="nk-tb-col"><span class="sub-text text-center">Link</span></div>
                      <div class="nk-tb-col"><span class="sub-text">Clicks</span></div>
                      <div class="nk-tb-col"><span class="sub-text">Amount</span></div>
                      <div class="nk-tb-col"><span class="sub-text">Type</span></div>
                      <div class="nk-tb-col"><span class="sub-text">Status</span></div>
                      <div class="nk-tb-col text-right"><span class="sub-text">Action</span></div>
                    </div>
                    {filteredData.length > 0 &&
                      (ctx.sts.perms.includes("413") ||
                        ctx.sts.perms.includes("9999")) ? (
                      filteredData.map((item, key) => {
                        return (
                          <>

                            <div class="nk-tb-item ">

                              <div class="nk-tb-col">
                                {key + 1}
                              </div>
                              <div class="nk-tb-col">
                                {item.link_title}
                                <br />
                                <p style={{ fontSize: 11, fontWeight: 300 }}>
                                  {item.link_code}
                                </p>
                              </div>
                              <div class="nk-tb-col">
                                <div class="project-info">
                                  <div style={{ display: "flex", gap: "16px" }}>
                                    <DirectLinkRow code={item.link} />
                                  </div>
                                </div>
                              </div>
                              <div class="nk-tb-col">
                                <div class="project-info">
                                  <Badge className="badge-dim" color={"warning"}>
                                    {item.clicks}
                                  </Badge>
                                </div>
                              </div>
                              <div class="nk-tb-col">
                                <Badge className="badge-dim" color={"primary"}>
                                  ${item.amount_generated.toFixed(5)}
                                </Badge>
                              </div>
                              <div class="nk-tb-col">
                                {item.is_adult === 1 &&
                                  item.is_mainstream === 1 ? (
                                  <span>
                                    <Badge
                                      className="badge-dim"
                                      color={
                                        item.is_adult === 1
                                          ? "warning"
                                          : item.is_mainstream === 1
                                            ? "primary"
                                            : "warning"
                                      }
                                    >
                                      Adult{" "}
                                    </Badge>
                                    &nbsp;&nbsp;
                                    <Badge
                                      className="badge-dim"
                                      color={
                                        item.is_adult === 1
                                          ? "success"
                                          : item.is_mainstream === 1
                                            ? "primary"
                                            : "warning"
                                      }
                                    >
                                      Mainstream
                                    </Badge>
                                  </span>
                                ) : item.is_adult === 1 ? (
                                  <span>
                                    <Badge className="badge-dim" color="warning">
                                      Adult{" "}
                                    </Badge>
                                    <br />
                                  </span>
                                ) : item.is_mainstream === 1 ? (
                                  <span>
                                    <Badge className="badge-dim" color="success">
                                      Mainstream{" "}
                                    </Badge>
                                    <br />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div class="nk-tb-col">
                                {item.suspended == 1 ? (
                                  <Badge className="badge-dim badge badge-danger">
                                    Suspended
                                  </Badge>
                                ) : item.status === 0 ? (
                                  <Badge className="badge-dim" color="success">
                                    Active
                                  </Badge>
                                ) : item.status === 2 ? (
                                  <Badge className="badge-dim hold">
                                    Hold
                                  </Badge>
                                ) : (
                                  <Badge className="badge-dim inactive">
                                    Inactive
                                  </Badge>
                                )}
                              </div>

                              <div class="nk-tb-col text-right">
                                {(item.suspended === 0) ?
                                  <span className="align-items-right" style={{ flex: 0.1 }}>
                                    <span
                                      onClick={() => {
                                        setErrors("");
                                        setModalTabForm(true);
                                        setEditeventId(item.id);
                                        setFormData(item);
                                      }}
                                      className="btn btn-primary btn-sm py-1 px-1"
                                      size="sm"
                                      color="primary"
                                    >
                                      <Icon name="edit" size="sm" />
                                    </span>
                                  </span>
                                  : <span className="align-items-right" style={{ flex: 0.1 }}></span>}
                              </div>
                            </div>
                          </>
                        );
                      })
                    ) : ''}

                  </div>
                </div>

                <div className="card-inner" style={{ display: "flex", gap: "20px"}}>
                  <div style={{ alignSelf: "self-start", width: "97%" }}>
                    {data.length > 0 ? (
                      <PaginationComponent
                        itemPerPage={itemPerPage}
                        currentPage={currentPage}
                        totalItems={pgs}
                        paginate={paginate}
                      />
                    ) : (
                      <div className="text-center">
                        <span className="text-silent">Data Not Found!</span>
                      </div>
                    )}
                  </div>
                  <div style={{ alignSelf: "end" }}>
                    <UncontrolledDropdown>
                      <DropdownToggle tag="a" className="dropdown-toggle bg-white btn btn-sm btn-outline-light btn-icon">
                        &nbsp; &nbsp; {itemPerPage} <Icon name="downward-ios"></Icon>
                      </DropdownToggle>
                      <DropdownMenu right>
                        <ul className="link-list-opt no-bdr">
                          <li onClick={() => { }}>
                            <DropdownItem
                              tag="a"
                              href="#"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(10);
                                getWebData("", skey, 1, 10);
                              }}
                            >
                              <span>10</span>
                            </DropdownItem>
                          </li>
                          <li onClick={() => { }}>
                            <DropdownItem
                              tag="a"
                              href="#"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(20);
                                getWebData("", skey, 1, 20);
                              }}
                            >
                              <span>20</span>
                            </DropdownItem>
                          </li>
                          <li onClick={() => { }}>
                            <DropdownItem
                              tag="a"
                              href="#"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(50);
                                getWebData("", skey, 1, 50);
                              }}
                            >
                              <span>50</span>
                            </DropdownItem>
                          </li>
                          <li onClick={() => { }}>
                            <DropdownItem
                              tag="a"
                              href="#"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(100);
                                getWebData("", skey, 1, 100);
                              }}
                            >
                              <span>100</span>
                            </DropdownItem>
                          </li>
                          <li onClick={() => { }}>
                            <DropdownItem
                              tag="a"
                              href="#"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(500);
                                getWebData("", skey, 1, 500);
                              }}
                            >
                              <span>500</span>
                            </DropdownItem>
                          </li>
                        </ul>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              </div>
            </div>
          </Block >
        </Content >
      </React.Fragment >

      <Modal
        isOpen={modalTabForm}
        toggle={toggleTabForm}
        size="md"
        modalClassName="modal-top"
        style={{ display: "block", top: "20%", marginTop: "0" }}
        contentClassName="border-0 shadow"
      >
        <ModalHeader
          toggle={toggleTabForm}
          close={
            <button className="close" onClick={toggleTabForm}>
              <Icon name="cross" />
            </button>
          }
        >
          {editeventId ? "Update Direct Link" : "Add Direct Link"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(onFormSubmit)} style={{ padding: '3%' }}>
            <FormGroup>
              <label
                className="form-label mt-3"
                htmlFor="fw-token-address"
              >
                Direct Link{" "}
              </label>
              <div className="form-control-wrap mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="link_title"
                  placeholder="Enter Your Link Title"
                  defaultValue={editeventId ? formData.link_title : ""}
                  onChange={handleChange}
                />
                {errors.link_title && (
                  <span className="text-danger mt-1" style={{ fontSize: 13 }} >{errors.link_title}
                    {/* {errors.link_title ? "Please enter direct link title" : ""} */}
                  </span>
                )}
              </div>
            </FormGroup>
            <br />
            <div className="row">
              <div className="col-3 d-flex align-items-center">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="is_adult"
                    name="is_adult"
                    checked={formData.is_adult ?? 1}
                    onChange={handleChange}
                  />
                  <label className="custom-control-label" htmlFor="is_adult">
                    Adult
                  </label>
                </div>
              </div>
              <div className="col-4 d-flex align-items-center">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="is_mainstream"
                    name="is_mainstream"
                    checked={formData.is_mainstream ?? 1}
                    onChange={handleChange}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="is_mainstream"
                  >
                    Mainstream
                  </label>
                </div>
              </div>
            </div>
            {errors.ads && (
              <div className="text-danger mt-2">{errors.ads}</div>
            )}

            <div className="d-flex justify-content-end mt-3">
              <Button type="submit" color="primary">
                {editeventId ? "Update" : "Submit"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PubDirectLink;
